import { combineEpics } from 'redux-observable';

import addFavoritesAction from './modules/common/redux/epics/addFavoritesAction';
import deleteFavoritesAction from './modules/common/redux/epics/deleteFavoritesAction';
import getChannel from './modules/common/redux/epics/getChannel';
import getChannels from './modules/common/redux/epics/getChannels';
import getConfig from './modules/common/redux/epics/getConfig';
import getFavoritesAction from './modules/common/redux/epics/getFavoritesAction';
import getInvitationList from './modules/common/redux/epics/getInvitationList';
import getSharedTeamList from './modules/common/redux/epics/getSharedTeamList';
import resourceRefreshAction from './modules/common/redux/epics/resourceRefreshAction';
import revokeInvitation from './modules/common/redux/epics/revokeInvitation';
import revokeShare from './modules/common/redux/epics/revokeShare';
import searchTeamList from './modules/common/redux/epics/searchTeamList';
import sendInvitation from './modules/common/redux/epics/sendInvitation';
import sendShare from './modules/common/redux/epics/sendShare';
import createComment from './modules/PlayerOverview/redux/epics/createComment';
import deleteComment from './modules/PlayerOverview/redux/epics/deleteComment';
import editComment from './modules/PlayerOverview/redux/epics/editComment';
import getCommentsAndSummary from './modules/PlayerOverview/redux/epics/getCommentsAndSummary';
import getCommentsUserList from './modules/PlayerOverview/redux/epics/getCommentsUserList';
import getDefaultOverview from './modules/PlayerOverview/redux/epics/getDefaultOverview';
import getShareOverview from './modules/PlayerOverview/redux/epics/getShareOverview';
import getSingleOverview from './modules/PlayerOverview/redux/epics/getSingleOverview';
import getSlides from './modules/PlayerOverview/redux/epics/getSlides';
import getTranscript from './modules/PlayerOverview/redux/epics/getTranscript';
import getXRayOverview from './modules/PlayerOverview/redux/epics/getXRayOverview';
import autocomplete from './modules/Search/redux/epics/autocomplete';
import deepSearch from './modules/Search/redux/epics/deepSearch';
import search from './modules/Search/redux/epics/search';
import searchAi from './modules/Search/redux/epics/searchAi';

export default combineEpics(
  getConfig,
  getCommentsUserList,
  createComment,
  editComment,
  deleteComment,
  getTranscript,
  getSlides,
  getCommentsAndSummary,
  getSharedTeamList,
  searchTeamList,
  sendShare,
  revokeShare,
  getInvitationList,
  sendInvitation,
  revokeInvitation,
  getFavoritesAction,
  addFavoritesAction,
  resourceRefreshAction,
  deleteFavoritesAction,
  autocomplete,
  deepSearch,
  getChannel,
  getChannels,
  getDefaultOverview,
  getShareOverview,
  getSingleOverview,
  getXRayOverview,
  search,
  searchAi,
);
